import { getData } from "../../sites/scripts/site.utilities";

export class CTMSHomeSitesSection {

    items: any[];
    itemsTable: any;
    tableSelector = '#sitesTable';

    url: string;
    showSiteColumn: boolean;

    constructor(handlerUrl: string){
        this.url = handlerUrl;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            // order: [[6, 'asc']],
            orderCellsTop: true,
            columns: [
                { data:'SiteName', title: 'Site Name', className: '' },
                { data:'SiteNumber', title: 'Site Number', className: '' },
                {
                    data: null,
                    title: "Studies",
                    render: function (data, type, row) {
                        if (row.CTMSStudy && row.CTMSStudy.length > 0) {
                            return row.CTMSStudy
                                .map(ss => ss.Name ? ss.Name : "")
                                .filter(name => name)
                                .sort()
                                .join(", ");
                        }
                        return "";
                    }
                },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<a href="/secure/ctms/site-details?id=${row.Id}" title="Edit"><i class="ctms-icon-pencil"></i></a>`;
                    }
                }
            ]
        });


    }

    async loadData() {
        $('#sitesSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        $('#sitesSectionLoading').addClass('d-none');
    }
}